import { atom } from "recoil";

const clickedStartTimerAtom = atom({
  key: "clickedStartTimerState",
  default: false,
});

export default clickedStartTimerAtom;
